import axios, { AxiosError, AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { getCookie } from 'typescript-cookie';
import { BASE_API_URL } from '../const/environments.constants';
import { ESession } from '../enums/auth.enum';
import i18n from '../plugins/i18n';

const getBaseUrl = (): string => BASE_API_URL || '';

const API = axios.create({
    baseURL: getBaseUrl(),
});

API.interceptors.request.use((req: InternalAxiosRequestConfig) => {
    const token = getCookie(ESession.JWT);
    const smallFleetID = getCookie(ESession.WORKSPACE);

    if (!(req.data instanceof FormData)) {
        req.headers['Content-Type'] = 'application/json';
    }
    req.headers['content-language'] = i18n.language || 'es';
    req.headers.utcoffset = '-300';

    if (token && req.headers) {
        req.headers.Authorization = `Bearer ${token}`;
    }

    if (smallFleetID && req.headers) {
        req.headers.smallFleetID = smallFleetID;
    }

    return req;
});

API.interceptors.response.use(
    (response: AxiosResponse) => response.data,
    (error: AxiosError) => Promise.reject(error.response?.data),
);

export { API, getBaseUrl };
